/* eslint-disable react/no-this-in-sfc */
import * as Yup from 'yup'
import React, { useContext, useState } from 'react'
import useQuery from 'hooks/useQuery'
import { Roles } from 'utils/enums'
import { AdminDataContext } from 'context/AdminDataContext'
import { useNavigate } from 'react-router-dom'
import RolesForm from './RolesForm'

const formRoles = [Roles.Translator, Roles.Client, Roles.Mediator]
function RolesRegisterFormContainer() {
  const {
    mediators,
    specialities,
    fetchMediators,
    fetchSpecialities,
    fetchClients,
    fetchTranslators,
  } = useContext(AdminDataContext)
  const navigate = useNavigate()
  const { makeRequest } = useQuery({
    defaultMethod: 'post',
    isControlled: true,
    toastOptions: { showFeedbackMessage: true },
  })

  const referenceFields = {
    [Roles.Client.role]: [
      {
        data: mediators,
        fieldName: 'mediatorId',
        validation: Yup.string().required('Obligatorio'),
      },
    ],
    get [Roles.Translator.role]() {
      return this[Roles.Client.role]
    },
  }

  const inputsWithOptions = {
    [Roles.Client.role]: [
      {
        data: specialities,
        fieldName: 'speciality',
        validation: Yup.string()
          .min(3, 'Debe tener al menos 3 caracteres')
          .max(40, 'Debe tener como mucho 40 caracteres')
          .required('Obligatorio'),
      },
    ],
  }

  const [errorStatus, setErrorStatus] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const onSubmitForm = async ({
    values,
    role: roleObject,
    reset,
    setSubmitting,
  }) => {
    const registerResponse = await makeRequest({
      endpoint: `/register/${roleObject.mainPath}`,
      body: values,
    })
    setSubmitting(false)
    if (registerResponse.error) {
      setErrorStatus(registerResponse.status)
      setErrorMessage(registerResponse.message)
      return
    }
    if (
      roleObject.role === Roles.Client.role
    ) {
      await fetchClients()
      if (!specialities.some((s) => s.name === values.speciality)) {
        await fetchSpecialities()
      }
    } else if (roleObject.role === Roles.Mediator.role) {
      await fetchMediators()
    } else if (roleObject.role === Roles.Translator.role) {
      await fetchTranslators()
    }
    reset()
    navigate(`/admins/management/${roleObject.mainPath}`)
  }
  return (
    <RolesForm
      onSubmitForm={onSubmitForm}
      error={errorStatus}
      errorMessage={errorMessage}
      rolesToShow={formRoles}
      referenceFields={referenceFields}
      inputsWithOptions={inputsWithOptions}
    />
  )
}

export default RolesRegisterFormContainer
